<span class="pos-relative basket-qty"
      [class.is-animate]="isAnimate"
      [attr.bullet]="basket?.qty || undefined"
      [attr.aria-label]="(basket?.qty ? ('basket quantity %' | translate : basket?.qty) + ', ' : '') + ('click to open minibasket' | translate)">
    <i class="icon-basket"
       aria-hidden="true"
       cy-basketBtn></i>
</span>